import type { EnvironmentCore } from '../environment'
import { defaultProductionConfig, productionHostname } from '../environment'
import { normalizeEnv } from './normalizeEnv'

export const generateEnvironmentFile = (source: Record<string, unknown>): EnvironmentCore => {
  try {
    const httpHost = typeof source.httpHost === 'string' ? source.httpHost : ''
    const httpPort = typeof source.httpPort === 'number' ? source.httpPort : 443
    const aiRoutingAssistantUrl =
      typeof source.aiRoutingAssistantUrl === 'string' ? source.aiRoutingAssistantUrl : ''
    const qa = source.qa === 'enable' || source.qa === 'disable' ? source.qa : 'disable'
    const env = normalizeEnv(source.env)

    return { httpHost, httpPort, qa, env, aiRoutingAssistantUrl }
  } catch (error) {
    if (window.location.hostname === productionHostname) {
      // avoid disasters in production
      return defaultProductionConfig
    } else {
      throw error
    }
  }
}
